import ui from './ui';
import user from './user';
import dynamic from './dynamic';
import output from './output';
import manifest from './manifest';
import notification from './notification';
import log from './log';

const actionCreators = {
  notification,
  manifest,
  ui,
  log,
  dynamic,
  output,
  user,
};

export default actionCreators;
